export interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (evt: React.MouseEvent<HTMLButtonElement>, page: number) => void;
}

const ROOT: React.CSSProperties = {
  display: 'flex',
  flexShrink: 0,
  marginLeft: 20,
};

const ICON_BTN: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: 8,
  display: 'inline-flex',
  alignItems: 'center',
  color: 'var(--chakra-colors-fg)',
};

const ICON_BTN_DISABLED: React.CSSProperties = {
  ...ICON_BTN,
  color: '#CCC',
  cursor: 'not-allowed',
};

const Svg = ({ d }: { d: string }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d={d} />
  </svg>
);

const First = () => <Svg d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />;
const Prev = () => <Svg d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z" />;
const Next = () => <Svg d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />;
const Last = () => <Svg d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />;

export const TablePaginationActions = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: TablePaginationActionsProps) => {
  const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
  const atStart = page === 0;
  const atEnd = page >= lastPage;

  return (
    <div style={ROOT}>
      <button
        type="button"
        onClick={(e) => onPageChange(e, 0)}
        disabled={atStart}
        aria-label="first page"
        style={atStart ? ICON_BTN_DISABLED : ICON_BTN}
      >
        <First />
      </button>
      <button
        type="button"
        onClick={(e) => onPageChange(e, page - 1)}
        disabled={atStart}
        aria-label="previous page"
        style={atStart ? ICON_BTN_DISABLED : ICON_BTN}
      >
        <Prev />
      </button>
      <button
        type="button"
        onClick={(e) => onPageChange(e, page + 1)}
        disabled={atEnd}
        aria-label="next page"
        style={atEnd ? ICON_BTN_DISABLED : ICON_BTN}
      >
        <Next />
      </button>
      <button
        type="button"
        onClick={(e) => onPageChange(e, lastPage)}
        disabled={atEnd}
        aria-label="last page"
        style={atEnd ? ICON_BTN_DISABLED : ICON_BTN}
      >
        <Last />
      </button>
    </div>
  );
};
